// Color option type for color selectors
export interface ColorOption {
  value: string;
  name: string;
}

// Hair color mappings to approximate hex values
export const HAIR_COLOR_OPTIONS: ColorOption[] = [
  { value: "none", name: "Bald" },
  { value: "#1c1c1c", name: "Black" },
  { value: "#4a3728", name: "Dark Brown" },
  { value: "#8b6f47", name: "Medium Brown" },
  { value: "#a67c52", name: "Light Brown" },
  { value: "#c8ad7f", name: "Dirty Blonde" },
  { value: "#e6d690", name: "Blonde" },
  { value: "#f5f0d0", name: "Platinum Blonde" },
  { value: "#a0522d", name: "Red" },
  { value: "#71331E", name: "Auburn" },
  { value: "#d2691e", name: "Strawberry Blonde" },
  { value: "#b22222", name: "Ginger" },
  { value: "#B87333", name: "Copper" },
  { value: "#808080", name: "Gray" },
  { value: "#595959", name: "Salt-and-Pepper" },
  { value: "#f5f5f5", name: "White" },
];

// Eye color mappings
export const EYE_COLOR_OPTIONS: ColorOption[] = [
  { value: "#4a90c2", name: "Blue" },
  { value: "#8b6914", name: "Brown" },
  { value: "#228b5a", name: "Green" },
  { value: "#a0845c", name: "Hazel" },
  { value: "#6b7d8c", name: "Gray" },
  { value: "#2c1810", name: "Black" },
];

// Skin tone mappings (using appropriate skin tone colors)
export const SKIN_TONE_OPTIONS: ColorOption[] = [
  { value: "#f7ddd4", name: "Very Fair" },
  { value: "#f2d3a7", name: "Fair" },
  { value: "#dbb989", name: "Medium" },
  { value: "#c49973", name: "Olive" },
  { value: "#8d5a2b", name: "Brown" },
  { value: "#5d4037", name: "Black" },
];
